import React from 'react';
import './MybookingCardSkeleton.css';

export default function MybookingCardSkeleton() {
  return (
    <div className="mybooking-card-section ">
      <div className="mybooking-card-container">
        <div className="mybooking-card-content">
          <div className="mybooking-card-content-img shimmer-box" />
          <div className="mybooking-card-content-text">
            <div className="mcct-title-section">
              <div className="shimmer-line title-line" />
              <div className="shimmer-circle qr-circle" />
            </div>
            <div className="shimmer-line venue-line" />
            <div className="mcct-date-time-guest">
              <div className="shimmer-line small-line" />
              <div className="shimmer-line small-line" />
              <div className="shimmer-line small-line" />
            </div>
            <div className="shimmer-line address-line" />
            <div className="mcct-amount-section">
              <div className="shimmer-line amount-line" />
              <div className="shimmer-line amount-line" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
